//src/pages/DashboardInactive.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DashboardLayout from '../layouts/DashboardLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward, faTimes, faClockRotateLeft, faTrophy, faPlugCircleExclamation, faHeartCircleExclamation, faExclamationCircle, faQuestionCircle, faSchoolCircleCheck, faMedal } from '@fortawesome/free-solid-svg-icons';
import '../styles/Dashboard.css';
import '../styles/Tooltip.css';

import DashboardGridData from '../components/DashboardGridDataInactive';
import MainLayout from '../layouts/MainLayout';

const DashboardInactive = () => {

  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const titleStyle = {
    color: module.isActive ? 'white' : 'gray',
    fontSize: '12px'
  };

  // Sort DashboardGridData first
const sortedDashboardData = DashboardGridData.sort((a, b) => {
  if (a.isActive !== b.isActive) return Number(b.isActive) - Number(a.isActive); // Active first
  if (a.moduleCat.localeCompare(b.moduleCat) !== 0) 
    return a.moduleCat.localeCompare(b.moduleCat); // Alphabetical order
  if (a.tabSN !== b.tabSN) return a.tabSN - b.tabSN; // Ascending order
  return a.title.localeCompare(b.title); // Alphabetical order
});

// Group modules by moduleCat
const groupedModules = sortedDashboardData.reduce((acc, module) => {
  if (!acc[module.moduleCat]) {
    acc[module.moduleCat] = [];
  }
  acc[module.moduleCat].push(module);
  return acc;
}, {});

// Create an array of categories from groupedModules and sort by tabSN
const sortedCategories = Object.keys(groupedModules).sort((a, b) => {
  const tabSN_A = sortedDashboardData.find(module => module.moduleCat === a)?.tabSN || 0; 
  const tabSN_B = sortedDashboardData.find(module => module.moduleCat === b)?.tabSN || 0;
  return tabSN_A - tabSN_B; // Ascending order
});

// Set the first category as active
const [activeCategory, setActiveCategory] = useState(sortedCategories[0]);
const [categoryInfo, setCategoryInfo] = useState('Think5Whys');

  // Function to handle category tab click
  const handleTabClick = (category) => {
    setActiveCategory(category);
    setCategoryInfo(category);
    setIsOverlayVisible(true); 
  };

  // useEffect(() => {
  //   getCategoryInfo(activeCategory);
  // }, [activeCategory]);

  const closeOverlay = () => {
    setIsOverlayVisible(false); 
  };

  // Function to return the FontAwesome icon based on the category
  const getCategoryIcon = (category) => {
    switch (category) {
      case 'Learning & Development':
        return <i className="fas fa-book-reader"></i>;
      case 'Improvement & Productivity':
        return <i className="fas fa-chart-line"></i>;
      case 'Product Marketplace':
        return <i className="fas fa-shopping-cart"></i>;
      case 'ThinkServices':
        return <i className="fas fa-laptop-house"></i>;
      case 'ThinkBPM':
        return <i className="fas fa-briefcase"></i>;
      case 'Pados / Locality':
        return <i className="fas fa-home"></i>;
      case 'Personal Information':
        return <i className="fas fa-user-circle"></i>;
      case 'ThinkSocial':
        return <i className="fas fa-users"></i>;
      case 'Daily Life':
        return <i className="fas fa-heart"></i>;
      case 'ThinkHealth':
        return <i className="fas fa-heartbeat"></i>;
      case 'ThinkJobs':
        return <i className="fas fa-briefcase"></i>;
      case 'Insight & Intelligence':
        return <i className="fas fa-lightbulb"></i>;
      case 'ThinkAds':
        return <i className="fas fa-gift"></i>;
      case 'ThinkAgri':
        return <i className="fas fa-tractor"></i>;
      case 'ThinkFinance':
        return <i className="fas fa-chart-line"></i>;  
      case 'ThinkContract':
        return <i className="fas fa-network-wired"></i>;  
      case 'ThinkExim':
        return <i className="fas fa-arrow-right-from-bracket"></i>;
      case 'ThinkEvent':
        return <i className="fas fa-calendar-day"></i>;
      case 'Tonics':
          return <i className="fas fa-question"></i>;
      case 'Community360':
          return <i className="fas fa-cubes"></i>;  
      case 'EarlySpark':
          return <i className="fas fa-fire"></i>;  
      case 'SkillSphere':
          return <i className="fas fa-wrench"></i>;  
      case 'ThinkTestBook':
          return <i className="fas fa-pen"></i>;    
      case 'CAP':
          return <i className="fas fa-graduation-cap"></i>;  
      case 'Coach':
        return <i className="fas fa-chalkboard-teacher"></i>;   
      case 'ThinkMath':
          return <i className="fas fa-calculator"></i>;                                           
      default:
        return <i className="fas fa-cube"></i>;
    }
  };

  // Function to return the FontAwesome icon based on the category
  const getCategoryInfo = (category) => {
    switch (category) {
      case 'Learning & Development':
        return "Immersive Learning & Development";
      case 'Improvement & Productivity':
        return "Improvement & Productivity with Six Sigma for Public";
      case 'Product Marketplace':
        return "Comprehensive Product Marketplace";
      case 'ThinkServices':
        return "Comprehensive Services Marketplace";
      case 'ThinkBPM':
        return "Business Process Manageemnt & Project Management";
      case 'Pados / Locality':
        return "Pados / Locality";
      case 'Personal Information':
        return "Personal Information";
      case 'ThinkSocial':
        return "Social Modules";
      case 'Daily Life':
        return "Life & Busines Chronicles";
      case 'ThinkHealth':
        return "Healthcare Monitoring Modules";
      case 'ThinkJobs':
        return "Vertical Jobs";
      case 'BigData':
        return "Insight & Intelligence";
      case 'ThinkAds':
        return "Rewarding Ads";
      case 'ThinkAgri':
        return "Better Agriculture";
      case 'ThinkFinance':
        return "Managing Financial Aspects of Life";
      case 'ThinkContract':
        return "Comprehensive COntract Management Module"; 
      case 'ThinkExim':
        return "Export Import Marketplace";
      case 'ThinkEvent':
        return "End-to-End Event Management";
      case 'Tonics':
        return "Daily Doses of Knowledge";
      case 'Community360':
        return "End-to-End Community, Association, Society Management";  
      case 'EarlySpark':
        return "Immersive Educational Platform for School & Junior Colleges";  
      case 'SkillSphere':
        return "Skill Development Learning Programs"; 
      case 'ThinkTestBook':
        return "Immersive Test Series - MCQ & AI Powered Descriptive Questions";    
      case 'CAP':
        return "Immersive Digital Cources & Programs";  
      case 'D-SCUT':
        return "Digital School, College, University, Coaching, Tuition";   
      case 'ThinkMath':
        return "Maths Sphere";                                           
      default:
        return "Think5Whys: Elevate Your Thinking From Why To Wisdom";
    }
  };

  
  return (
    <DashboardLayout includeNavbarAndFooter={true}>
      <div className="min-h-full py-2 bg-gradient-to-r from-gray-800 via-lime-800 to-gray-800">
        <h3 className='text-xl font-bold text-white text-center mb-4'>User Others Dashboard</h3>
        {/* Tab Navigation in Grid Form with FontAwesome Icons */}
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 mb-250 mx-4">
          {Object.keys(groupedModules).map((category) => (
            <button
              key={category}
              onClick={() => handleTabClick(category)}
              className="flex flex-col items-center justify-center w-full max-w-xs p-4 bg-gradient-to-r from-teal-800 to-blue-800 text-white font-semibold rounded-lg shadow-md transform hover:scale-105 transition-all duration-300 ease-out sm:w-auto"

            >
              {/* Icon above the category name */}
              <div style={{ fontSize: '24px', marginBottom: '10px' }}>
                {getCategoryIcon(category)}
              </div>
              <span className="text-m font-semibold flex items-center justify-center text-center">{category}</span>
            </button>
          ))}
        </div>

        {/* Overlay for Modules Display */}
        {isOverlayVisible && (

          <div
            className="overlay"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'darkblue',
              display: 'flex',
              flexDirection: 'column', 
              alignItems: 'center', 
              zIndex: 100,
              padding: '20px',
              overflowY: 'auto', 
            }}
          >
          <div>
            {/* First Close Icon */}
            <button
              onClick={closeOverlay}
              style={{
                background: 'none',
                border: 'none',
                color: 'red',
                fontSize: '24px',
                cursor: 'pointer',
                marginBottom: '20px', 
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>    

          <div className='flex justify-center mt-12 mb-4 text-xl text-yellow-200'>{activeCategory}</div>
          {/* <div className='flex justify-center mt-4 mb-4 text-xl text-yellow-200'>{categoryInfo}</div> */}

          {/* Module Display Area */}
          <div className="min-h-full grid grid-cols-2 sm:grid-cols-6 gap-6 mb-4">
            {groupedModules[activeCategory]
              .sort((a, b) => b.isActive - a.isActive)
              .map((module, index) => (
                <div key={index} className="module-card" style={{ textAlign: 'center', margin: '15px', width: '150px' }}>
                  {module.isActive ? (
                    <Link to={module.landingPageUrl} style={{ textDecoration: 'none', color: 'inherit' }}>
                      <img
                        src={module.imageUrl}
                        alt={module.title}
                        width="100%"
                        height="auto"
                        style={{ borderRadius: '8px', marginBottom: '10px' }}
                      />
                      <div className="module-title" style={{ color: '#fff', fontSize: '14px', fontWeight: 'bold' }}>
                        {module.title}
                      </div>
                    </Link>
                  ) : (
                    <>
                      <img
                        src={module.imageUrl}
                        alt={module.title}
                        width="100%"
                        height="auto"
                        style={{ borderRadius: '8px', marginBottom: '10px', opacity: '0.5' }}
                      />
                      <div className="module-title" style={{ color: 'gray', fontSize: '14px' }}>
                        {module.title}
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>

            {/* Second Close Icon */}
            <button
              onClick={closeOverlay}
              style={{
                background: 'none',
                border: 'none',
                color: 'red',
                fontSize: '24px',
                cursor: 'pointer',
                marginTop: '20px', 
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}

export default DashboardInactive;
